export enum ComponentId {
  APPLICANT_NAME = "name",
  APPLICANT_SURNAME = "surname",
  APPLICANT_PHONE = "phone",
  APPLICANT_EMAIL = "email",
  APPLICANT_IS_DRIVER = "isDriver",
}
